// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as Recoil$OrcaPaymentPage from "../libraries/Recoil.bs.js";
import * as S3Utils$OrcaPaymentPage from "./S3Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as Constants$OrcaPaymentPage from "./Constants.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./PaymentBody.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./RecoilAtoms.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as PayPalHelpers$OrcaPaymentPage from "../Payments/PayPalHelpers.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/CardValidations.bs.js";
import * as PaymentModeType$OrcaPaymentPage from "../Types/PaymentModeType.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./UnifiedHelpersV2.bs.js";
import * as CountryStateDataRefs$OrcaPaymentPage from "../CountryStateDataRefs.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

var paymentMethodListValue = Recoil$OrcaPaymentPage.atom("paymentMethodListValue", PaymentMethodsRecord$OrcaPaymentPage.defaultList);

var paymentManagementListValue = Recoil$OrcaPaymentPage.atom("paymentManagementListValue", UnifiedHelpersV2$OrcaPaymentPage.defaultPaymentsList);

function paymentListLookupNew(list, order, isShowPaypal, isShowKlarnaOneClick, isKlarnaSDKFlow, paymentMethodListValue, areAllGooglePayRequiredFieldsPrefilled, isGooglePayReady, shouldDisplayApplePayInTabs, shouldDisplayPayPalInTabs, localeString, showWalletsWithOtherPaymentMethods) {
  var pmList = PaymentMethodsRecord$OrcaPaymentPage.buildFromPaymentList(list, localeString);
  var walletsList = [];
  var walletToBeDisplayedInTabs = [
    "mb_way",
    "ali_pay",
    "ali_pay_hk",
    "mobile_pay",
    "we_chat_pay",
    "vipps",
    "twint",
    "dana",
    "go_pay",
    "kakao_pay",
    "gcash",
    "momo",
    "touch_n_go",
    "mifinity",
    "bluecode",
    "revolut_pay",
    "skrill"
  ];
  var otherPaymentList = [];
  if (shouldDisplayApplePayInTabs) {
    walletToBeDisplayedInTabs.push("apple_pay");
  }
  if (shouldDisplayPayPalInTabs) {
    walletToBeDisplayedInTabs.push("paypal");
  }
  var requiresGooglePayBillingDetails = !paymentMethodListValue.collect_billing_details_from_wallets && !areAllGooglePayRequiredFieldsPrefilled;
  var shouldDisplayGooglePayInTabs = isGooglePayReady && (showWalletsWithOtherPaymentMethods || requiresGooglePayBillingDetails);
  if (shouldDisplayGooglePayInTabs) {
    walletToBeDisplayedInTabs.push("google_pay");
  }
  pmList.forEach(function (item) {
        if (walletToBeDisplayedInTabs.includes(item.paymentMethodName)) {
          otherPaymentList.push(item.paymentMethodName);
          return ;
        }
        if (item.methodType === "wallet") {
          if (item.paymentMethodName !== "paypal" || isShowPaypal) {
            walletsList.push(item.paymentMethodName);
            return ;
          } else {
            return ;
          }
        }
        if (item.methodType === "bank_debit") {
          otherPaymentList.push(item.paymentMethodName + "_debit");
          return ;
        }
        if (item.methodType === "bank_transfer" && !Constants$OrcaPaymentPage.bankTransferList.includes(item.paymentMethodName)) {
          otherPaymentList.push(item.paymentMethodName + "_transfer");
          return ;
        }
        if (item.methodType === "card") {
          otherPaymentList.push("card");
          return ;
        }
        if (item.methodType === "reward") {
          otherPaymentList.push(item.paymentMethodName);
          return ;
        }
        if (item.methodType === "pay_later") {
          if (item.paymentMethodName === "klarna") {
            var klarnaPaymentMethodExperience = PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceTypeFromPML(paymentMethodListValue, item.methodType, item.paymentMethodName);
            var isInvokeSDKExperience = klarnaPaymentMethodExperience.includes("InvokeSDK");
            var isRedirectExperience = klarnaPaymentMethodExperience.includes("RedirectToURL");
            if (isKlarnaSDKFlow && isShowKlarnaOneClick && isInvokeSDKExperience) {
              walletsList.push(item.paymentMethodName);
              return ;
            } else if (isRedirectExperience) {
              otherPaymentList.push(item.paymentMethodName);
              return ;
            } else {
              return ;
            }
          }
          otherPaymentList.push(item.paymentMethodName);
          return ;
        }
        otherPaymentList.push(item.paymentMethodName);
      });
  var updatedWalletsList = showWalletsWithOtherPaymentMethods ? [] : walletsList;
  return [
          Utils$OrcaPaymentPage.sortBasedOnPriority(Utils$OrcaPaymentPage.removeDuplicate(updatedWalletsList), order),
          Utils$OrcaPaymentPage.sortBasedOnPriority(Utils$OrcaPaymentPage.removeDuplicate(otherPaymentList), order)
        ];
}

function getMethod(method) {
  if (typeof method !== "object") {
    return "crypto";
  }
  switch (method.TAG) {
    case "PayLater" :
        return "pay_later";
    case "Wallets" :
        return "wallet";
    case "Cards" :
        return "card";
    case "Banks" :
        return "bank_redirect";
    case "BankTransfer" :
        return "bank_transfer";
    case "BankDebit" :
        return "bank_debit";
    
  }
}

function getMethodType(method) {
  if (typeof method !== "object") {
    return "crypto_currency";
  }
  switch (method.TAG) {
    case "PayLater" :
        switch (method._0.TAG) {
          case "Klarna" :
              return "klarna";
          case "AfterPay" :
              return "afterpay_clearpay";
          case "Affirm" :
              return "affirm";
          
        }
    case "Wallets" :
        switch (method._0.TAG) {
          case "Gpay" :
              return "google_pay";
          case "ApplePay" :
              return "apple_pay";
          case "Paypal" :
              return "paypal";
          
        }
    case "Cards" :
        return "card";
    case "Banks" :
        switch (method._0) {
          case "Sofort" :
              return "sofort";
          case "Eps" :
              return "eps";
          case "GiroPay" :
              return "giropay";
          case "Ideal" :
              return "ideal";
          case "EFT" :
              return "eft";
          
        }
    case "BankTransfer" :
    case "BankDebit" :
        break;
    
  }
  switch (method._0) {
    case "ACH" :
        return "ach";
    case "Sepa" :
        return "sepa";
    case "Bacs" :
        return "bacs";
    case "Instant" :
        return "instant";
    
  }
}

function getExperience(val) {
  if (val === "Redirect") {
    return "redirect_to_url";
  } else {
    return "invoke_sdk_client";
  }
}

function getPaymentExperienceType(val) {
  switch (val) {
    case "InvokeSDK" :
        return "invoke_sdk_client";
    case "RedirectToURL" :
        return "redirect_to_url";
    case "QrFlow" :
        return "display_qr_code";
    
  }
}

function getExperienceType(method) {
  if (typeof method !== "object") {
    return "redirect_to_url";
  }
  switch (method.TAG) {
    case "PayLater" :
    case "Wallets" :
        return getExperience(method._0._0);
    case "Cards" :
        return "card";
    default:
      return "";
  }
}

function getConnectors(list, method) {
  var paymentMethod = list.payment_methods.find(function (item) {
        return item.payment_method === getMethod(method);
      });
  if (paymentMethod === undefined) {
    return [
            [],
            []
          ];
  }
  var paymentMethodType = paymentMethod.payment_method_types.find(function (item) {
        return item.payment_method_type === getMethodType(method);
      });
  if (paymentMethodType === undefined) {
    return [
            [],
            []
          ];
  }
  var experienceType = paymentMethodType.payment_experience.find(function (item) {
        return getPaymentExperienceType(item.payment_experience_type) === getExperienceType(method);
      });
  var eligibleConnectors = experienceType !== undefined ? experienceType.eligible_connectors : [];
  if (typeof method !== "object") {
    return [
            eligibleConnectors,
            []
          ];
  }
  switch (method.TAG) {
    case "Banks" :
        return [
                [],
                paymentMethodType.bank_names
              ];
    case "BankTransfer" :
        return [
                paymentMethodType.bank_transfers_connectors,
                []
              ];
    case "BankDebit" :
        return [
                paymentMethodType.bank_debits_connectors,
                []
              ];
    default:
      return [
              eligibleConnectors,
              []
            ];
  }
}

function getDisplayNameAndIcon(customNames, paymentMethodName, defaultName, defaultIcon) {
  var customNameObj = customNames.filter(function (item) {
          return item.paymentMethodName === paymentMethodName;
        })[0];
  if (customNameObj === undefined) {
    return [
            defaultName,
            defaultIcon
          ];
  }
  if (!(customNameObj.paymentMethodName === "classic" || customNameObj.paymentMethodName === "evoucher")) {
    return [
            defaultName,
            defaultIcon
          ];
  }
  var aliasName = customNameObj.aliasName;
  if (aliasName === "") {
    return [
            defaultName,
            defaultIcon
          ];
  }
  var id = aliasName.split(" ");
  return [
          aliasName,
          Caml_option.some(PaymentMethodsRecord$OrcaPaymentPage.icon(19, undefined, Core__Option.getOr(id[0], "")))
        ];
}

function getPaymentMethodName(paymentMethodType, paymentMethodName) {
  if (paymentMethodType === "bank_debit") {
    return paymentMethodName.replace("_debit", "");
  } else if (paymentMethodType === "bank_transfer" && !Constants$OrcaPaymentPage.bankTransferList.includes(paymentMethodName)) {
    return paymentMethodName.replace("_transfer", "");
  } else {
    return paymentMethodName;
  }
}

function isAppendingCustomerAcceptance(isGuestCustomer, paymentType) {
  if (isGuestCustomer) {
    return false;
  } else if (paymentType === "NEW_MANDATE") {
    return true;
  } else {
    return paymentType === "SETUP_MANDATE";
  }
}

function appendedCustomerAcceptance(isGuestCustomer, paymentType, body) {
  if (isAppendingCustomerAcceptance(isGuestCustomer, paymentType)) {
    return body.concat([[
                  "customer_acceptance",
                  PaymentBody$OrcaPaymentPage.customerAcceptanceBody
                ]]);
  } else {
    return body;
  }
}

function usePaymentMethodTypeFromList(paymentMethodListValue, paymentMethod, paymentMethodType) {
  return React.useMemo((function () {
                return Core__Option.getOr(PaymentMethodsRecord$OrcaPaymentPage.getPaymentMethodTypeFromList(paymentMethodListValue, paymentMethod, getPaymentMethodName(paymentMethod, paymentMethodType)), PaymentMethodsRecord$OrcaPaymentPage.defaultPaymentMethodType);
              }), [
              paymentMethodListValue,
              paymentMethod,
              paymentMethodType
            ]);
}

function useAreAllRequiredFieldsPrefilled(paymentMethodListValue, paymentMethod, paymentMethodType) {
  var paymentMethodTypes = usePaymentMethodTypeFromList(paymentMethodListValue, paymentMethod, paymentMethodType);
  return Core__Array.reduce(paymentMethodTypes.required_fields, true, (function (acc, requiredField) {
                if (acc) {
                  return requiredField.value !== "";
                } else {
                  return false;
                }
              }));
}

function getIsKlarnaSDKFlow(sessions) {
  var dict = Utils$OrcaPaymentPage.getDictFromJson(sessions);
  var sessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "Others");
  var klarnaTokenObj = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Klarna");
  if (klarnaTokenObj.TAG === "OtherTokenOptional") {
    return Core__Option.isSome(klarnaTokenObj._0);
  } else {
    return false;
  }
}

function usePaypalFlowStatus(sessions, paymentMethodListValue) {
  var sessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(sessions), "Others");
  var match = PayPalHelpers$OrcaPaymentPage.usePaymentMethodData(paymentMethodListValue, sessionObj);
  var paypalToken = match.paypalToken;
  var isPaypalTokenExist;
  isPaypalTokenExist = paypalToken.TAG === "OtherTokenOptional" ? paypalToken._0 !== undefined : false;
  return [
          match.isPaypalSDKFlow,
          match.isPaypalRedirectFlow,
          isPaypalTokenExist
        ];
}

function useGetPaymentMethodList(paymentOptions, paymentType, sessions) {
  var methodslist = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var paymentMethodOrder = match$1.paymentMethodOrder;
  var optionAtomValue = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var paymentOrder = Utils$OrcaPaymentPage.removeDuplicate(Utils$OrcaPaymentPage.getOptionalArr(paymentMethodOrder));
  var isKlarnaSDKFlow = getIsKlarnaSDKFlow(sessions);
  var paymentMethodListValue$1 = Recoil.useRecoilValue(paymentMethodListValue);
  var areAllApplePayRequiredFieldsPrefilled = useAreAllRequiredFieldsPrefilled(paymentMethodListValue$1, "wallet", "apple_pay");
  var areAllGooglePayRequiredFieldsPrefilled = useAreAllRequiredFieldsPrefilled(paymentMethodListValue$1, "wallet", "google_pay");
  var areAllPaypalRequiredFieldsPreFilled = useAreAllRequiredFieldsPrefilled(paymentMethodListValue$1, "wallet", "paypal");
  var isApplePayReady = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isApplePayReady);
  var isGooglePayReady = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isGooglePayReady);
  var match$2 = usePaypalFlowStatus(sessions, paymentMethodListValue$1);
  var isPaypalTokenExist = match$2[2];
  var isPaypalRedirectFlow = match$2[1];
  var isPaypalSDKFlow = match$2[0];
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(optionAtomValue.layout);
  var showWalletsWithOtherPaymentMethods = !layoutClass.displayOneClickPaymentMethodsOnTop && paymentType === "Payment";
  return React.useMemo((function () {
                if (typeof methodslist !== "object") {
                  if (methodslist === "Loading") {
                    return [
                            [],
                            [],
                            []
                          ];
                  } else if (Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder)) {
                    return [
                            [],
                            ["card"],
                            []
                          ];
                  } else {
                    return [
                            [],
                            [],
                            []
                          ];
                  }
                }
                if (methodslist.TAG !== "Loaded") {
                  return [
                          [],
                          [],
                          []
                        ];
                }
                var paymentOrder$1 = paymentOrder.length > 0 ? paymentOrder : PaymentModeType$OrcaPaymentPage.defaultOrder;
                var pList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(methodslist._0));
                var requiresApplePayBillingDetails = !paymentMethodListValue$1.collect_billing_details_from_wallets && !areAllApplePayRequiredFieldsPrefilled;
                var shouldDisplayApplePayInTabs = isApplePayReady && (showWalletsWithOtherPaymentMethods || requiresApplePayBillingDetails);
                var isShowPaypal = optionAtomValue.wallets.payPal === "Auto";
                var requiresPaypalBillingDetails = !paymentMethodListValue$1.collect_billing_details_from_wallets && !areAllPaypalRequiredFieldsPreFilled;
                var isPaypalEligibleInRedirectFlow = isShowPaypal && isPaypalRedirectFlow && (!isPaypalSDKFlow || !isPaypalTokenExist);
                var shouldDisplayPayPalInTabs = isPaypalEligibleInRedirectFlow && (showWalletsWithOtherPaymentMethods || requiresPaypalBillingDetails);
                var match = paymentListLookupNew(pList, paymentOrder$1, isShowPaypal, optionAtomValue.wallets.klarna === "Auto", isKlarnaSDKFlow, pList, areAllGooglePayRequiredFieldsPrefilled, isGooglePayReady, shouldDisplayApplePayInTabs, shouldDisplayPayPalInTabs, localeString, showWalletsWithOtherPaymentMethods);
                var otherOptions = match[1];
                var klarnaPaymentMethodExperience = PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceTypeFromPML(pList, "pay_later", "klarna");
                var isKlarnaInvokeSDKExperience = klarnaPaymentMethodExperience.includes("InvokeSDK");
                var filterPaymentMethods = function (paymentOptionsList) {
                  return paymentOptionsList.filter(function (paymentOptionsName) {
                              switch (paymentOptionsName) {
                                case "apple_pay" :
                                    return shouldDisplayApplePayInTabs;
                                case "klarna" :
                                    return !(isKlarnaSDKFlow && isKlarnaInvokeSDKExperience);
                                case "paypal" :
                                    return shouldDisplayPayPalInTabs;
                                default:
                                  return true;
                              }
                            });
                };
                return [
                        Utils$OrcaPaymentPage.getWalletPaymentMethod(Utils$OrcaPaymentPage.removeDuplicate(match[0]), paymentType),
                        filterPaymentMethods(Utils$OrcaPaymentPage.removeDuplicate(paymentOptions.concat(otherOptions))),
                        otherOptions
                      ];
              }), [
              methodslist,
              paymentMethodOrder,
              optionAtomValue.wallets.payPal,
              optionAtomValue.wallets.klarna,
              paymentType,
              showWalletsWithOtherPaymentMethods,
              isKlarnaSDKFlow,
              areAllApplePayRequiredFieldsPrefilled,
              areAllGooglePayRequiredFieldsPrefilled,
              areAllPaypalRequiredFieldsPreFilled,
              isPaypalSDKFlow,
              isPaypalRedirectFlow,
              isPaypalTokenExist,
              isApplePayReady,
              isGooglePayReady
            ]);
}

function useStatesJson(setStatesJson) {
  var stateList = CountryStateDataRefs$OrcaPaymentPage.stateDataRef.contents;
  React.useEffect((function () {
          setStatesJson(function (param) {
                return stateList;
              });
        }), []);
}

async function getStateJson(param) {
  try {
    return (await S3Utils$OrcaPaymentPage.getCountryStateData(undefined, undefined)).states;
  }
  catch (raw_err){
    var err = Caml_js_exceptions.internalToOCamlException(raw_err);
    console.error("Error importing states:", err);
    return null;
  }
}

function sortCustomerMethodsBasedOnPriority(sortArr, priorityArr, displayDefaultSavedPaymentIconOpt) {
  var displayDefaultSavedPaymentIcon = displayDefaultSavedPaymentIconOpt !== undefined ? displayDefaultSavedPaymentIconOpt : true;
  if (priorityArr.length === 0) {
    return sortArr;
  }
  var getPaymentMethod = function (customerMethod) {
    if (customerMethod.paymentMethod === "card") {
      return customerMethod.paymentMethod;
    }
    var paymentMethodType = customerMethod.paymentMethodType;
    if (paymentMethodType !== undefined) {
      return paymentMethodType;
    } else {
      return customerMethod.paymentMethod;
    }
  };
  var getCustomerMethodPriority = function (paymentMethod) {
    var priorityArrLength = priorityArr.length;
    var index = priorityArr.indexOf(paymentMethod);
    if (index === -1) {
      return priorityArrLength;
    } else {
      return index;
    }
  };
  var handleCustomerMethodsSort = function (firstCustomerMethod, secondCustomerMethod) {
    var firstPaymentMethod = getPaymentMethod(firstCustomerMethod);
    var secondPaymentMethod = getPaymentMethod(secondCustomerMethod);
    if (displayDefaultSavedPaymentIcon && (firstCustomerMethod.defaultPaymentMethodSet || secondCustomerMethod.defaultPaymentMethodSet)) {
      if (firstCustomerMethod.defaultPaymentMethodSet) {
        return -1;
      } else {
        return 1;
      }
    } else {
      return getCustomerMethodPriority(firstPaymentMethod) - getCustomerMethodPriority(secondPaymentMethod) | 0;
    }
  };
  return Belt_SortArray.stableSortBy(sortArr, handleCustomerMethodsSort);
}

function getSupportedCardBrands(paymentMethodListValue) {
  var cardPaymentMethod = paymentMethodListValue.payment_methods.find(function (ele) {
        return ele.payment_method === "card";
      });
  if (cardPaymentMethod === undefined) {
    return ;
  }
  var cardNetworks = cardPaymentMethod.payment_method_types.map(function (ele) {
        return ele.card_networks;
      });
  var cardNetworkNames = cardNetworks.map(function (ele) {
        return ele.map(function (val) {
                    return CardUtils$OrcaPaymentPage.getCardStringFromType(val.card_network).toLowerCase();
                  });
      });
  return Utils$OrcaPaymentPage.getUniqueArray(Core__Array.reduce(cardNetworkNames, [], (function (acc, ele) {
                    return acc.concat(ele);
                  })));
}

function checkIsCardSupported(cardNumber, cardBrand, supportedCardBrands) {
  var clearValue = CardValidations$OrcaPaymentPage.clearSpaces(cardNumber);
  if (cardBrand === "") {
    return CardUtils$OrcaPaymentPage.cardValid(clearValue, cardBrand);
  } else if (CardUtils$OrcaPaymentPage.cardValid(clearValue, cardBrand)) {
    if (supportedCardBrands !== undefined) {
      return supportedCardBrands.includes(cardBrand.toLowerCase());
    } else {
      return true;
    }
  } else {
    return ;
  }
}

function emitMessage(paymentMethodInfo) {
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "paymentMethodInfo",
          paymentMethodInfo
        ]]);
}

function emitPaymentMethodInfo(paymentMethod, paymentMethodType, cardBrandOpt, cardLast4Opt, cardBinOpt, cardExpiryMonthOpt, cardExpiryYearOpt, countryOpt, stateOpt, pinCodeOpt, isSavedPaymentMethodOpt) {
  var cardBrand = cardBrandOpt !== undefined ? cardBrandOpt : "NOTFOUND";
  var cardLast4 = cardLast4Opt !== undefined ? cardLast4Opt : "";
  var cardBin = cardBinOpt !== undefined ? cardBinOpt : "";
  var cardExpiryMonth = cardExpiryMonthOpt !== undefined ? cardExpiryMonthOpt : "";
  var cardExpiryYear = cardExpiryYearOpt !== undefined ? cardExpiryYearOpt : "";
  var country = countryOpt !== undefined ? countryOpt : "";
  var state = stateOpt !== undefined ? stateOpt : "";
  var pinCode = pinCodeOpt !== undefined ? pinCodeOpt : "";
  var isSavedPaymentMethod = isSavedPaymentMethodOpt !== undefined ? isSavedPaymentMethodOpt : false;
  var baseCardsFields = [
    [
      "cardBrand",
      CardUtils$OrcaPaymentPage.getCardStringFromType(cardBrand)
    ],
    [
      "cardLast4",
      cardLast4
    ],
    [
      "cardBin",
      cardBin
    ],
    [
      "cardExpiryMonth",
      cardExpiryMonth
    ],
    [
      "cardExpiryYear",
      cardExpiryYear
    ]
  ];
  var baseAddressFields = [
    [
      "country",
      country
    ],
    [
      "state",
      state
    ],
    [
      "pincode",
      pinCode
    ]
  ];
  var baseSavedPaymentField = [[
      "isSavedPaymentMethod",
      isSavedPaymentMethod
    ]];
  var basePaymentInfoFields = paymentMethod === "card" ? [[
        "paymentMethod",
        paymentMethod
      ]] : [
      [
        "paymentMethod",
        paymentMethod
      ],
      [
        "paymentMethodType",
        paymentMethodType
      ]
    ];
  var msg = cardBrand === "NOTFOUND" || paymentMethod !== "card" ? Belt_Array.concatMany([
          basePaymentInfoFields,
          baseAddressFields
        ]) : Belt_Array.concatMany([
          basePaymentInfoFields,
          baseAddressFields,
          baseCardsFields
        ]);
  var finalMsg = msg.filter(function (param) {
        return Core__Option.getOr(Core__JSON.Decode.string(param[1]), "") !== "";
      });
  emitMessage(Object.fromEntries(finalMsg.concat(baseSavedPaymentField)));
}

function useNonPiiAddressData() {
  var country = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userCountry);
  var state = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userAddressState).value;
  var pinCode = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userAddressPincode).value;
  return {
          country: country,
          state: state,
          pinCode: pinCode
        };
}

function useEmitPaymentMethodInfo(paymentMethodName, paymentMethods, cardProps, expiryProps) {
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var match = useNonPiiAddressData();
  var cardBrand = cardProps.cardBrand;
  var cardNumber = cardProps.cardNumber;
  var pinCode = match.pinCode;
  var state = match.state;
  var country = match.country;
  var cardBin = CardUtils$OrcaPaymentPage.getCardBin(cardNumber);
  var cardLast4 = CardUtils$OrcaPaymentPage.getCardLast4(cardNumber);
  var isCardValid = Core__Option.getOr(cardProps.isCardValid, false);
  var isExpiryValid = Core__Option.getOr(expiryProps.isExpiryValid, false);
  var match$1 = CardUtils$OrcaPaymentPage.getExpiryDates(expiryProps.cardExpiry);
  var cardExpiryYear = match$1[1];
  var cardExpiryMonth = match$1[0];
  var shouldEmitCardInfo = isCardValid && isExpiryValid && paymentMethodName === "card";
  var emitPaymentMethodInfoWrapper = function (paymentMethod, paymentMethodType) {
    if (shouldEmitCardInfo) {
      return emitPaymentMethodInfo(paymentMethodName, paymentMethodType, CardUtils$OrcaPaymentPage.getCardType(cardBrand), cardLast4, cardBin, cardExpiryMonth, cardExpiryYear, country, state, pinCode, undefined);
    } else {
      return emitPaymentMethodInfo(paymentMethod, paymentMethodType, undefined, undefined, undefined, undefined, undefined, country, state, pinCode, undefined);
    }
  };
  React.useEffect((function () {
          if (paymentMethodName.includes("_debit")) {
            emitPaymentMethodInfoWrapper("bank_debit", paymentMethodName);
          } else if (paymentMethodName.includes("_transfer")) {
            emitPaymentMethodInfoWrapper("bank_transfer", paymentMethodName);
          } else if (paymentMethodName === "card") {
            emitPaymentMethodInfoWrapper("card", "debit");
          } else {
            var finalOptionalPaymentMethodTypeValue = paymentMethods.filter(function (paymentMethodData) {
                    return paymentMethodData.payment_method_types.filter(function (paymentMethodType) {
                                return paymentMethodType.payment_method_type === paymentMethodName;
                              }).length > 0;
                  })[0];
            if (finalOptionalPaymentMethodTypeValue !== undefined) {
              emitPaymentMethodInfoWrapper(finalOptionalPaymentMethodTypeValue.payment_method, paymentMethodName);
            } else {
              loggerState.setLogError("Payment method type not found", "PAYMENT_METHOD_TYPE_DETECTION_FAILED", undefined, undefined, undefined, undefined, undefined);
            }
          }
        }), [
        paymentMethodName,
        cardBrand,
        paymentMethods,
        isCardValid,
        isExpiryValid,
        country,
        state,
        pinCode
      ]);
}

function checkRenderOrComp(walletOptions, isShowOrPayUsing, isShowOrPayUsingWhileLoadingOpt) {
  var isShowOrPayUsingWhileLoading = isShowOrPayUsingWhileLoadingOpt !== undefined ? isShowOrPayUsingWhileLoadingOpt : false;
  if (walletOptions.includes("paypal") || isShowOrPayUsing) {
    return true;
  } else {
    return isShowOrPayUsingWhileLoading;
  }
}

export {
  paymentMethodListValue ,
  paymentManagementListValue ,
  paymentListLookupNew ,
  getMethod ,
  getMethodType ,
  getExperience ,
  getPaymentExperienceType ,
  getExperienceType ,
  getConnectors ,
  getDisplayNameAndIcon ,
  getPaymentMethodName ,
  isAppendingCustomerAcceptance ,
  appendedCustomerAcceptance ,
  usePaymentMethodTypeFromList ,
  useAreAllRequiredFieldsPrefilled ,
  getIsKlarnaSDKFlow ,
  usePaypalFlowStatus ,
  useGetPaymentMethodList ,
  useStatesJson ,
  getStateJson ,
  sortCustomerMethodsBasedOnPriority ,
  getSupportedCardBrands ,
  checkIsCardSupported ,
  emitMessage ,
  emitPaymentMethodInfo ,
  useNonPiiAddressData ,
  useEmitPaymentMethodInfo ,
  checkRenderOrComp ,
}
/* paymentMethodListValue Not a pure module */
